<template>
  <div class="mycard">
    <div class="app-top-nav">
      <div class="item" @click="selcur('enable')" :class="[cur=='enable'?'cur':'']"><span>可用卡券</span></div>
      <div class="item" @click="selcur('get')" :class="[cur=='get'?'cur':'']"><span>收到卡券</span></div>
      <div class="item" @click="selcur('back')" :class="[cur=='back'?'cur':'']"><span>卡券退回</span></div>
      <div class="item" @click="selcur('used')" :class="[cur=='used'?'cur':'']"><span>已使用</span></div>
    </div>
      <div v-if="coupon && coupon.length > 0" class="list">
        <div v-if="cur=='enable'" v-for="(v,k) in coupon" v-bind:key="k" class="item">
          <div class="box">
            <div class="num">
              ￥<span>{{v.money}}</span>
            </div>
            <div class="txt">
              <p class="tit">{{v.title}}</p>
              <!-- <p class="stit">余额充值券</p> -->
            </div>
            <div class="btnbox">
              <div v-if="v.type==2" @click="transfer(v)" class="btn">转赠</div>
              <div @click="couponUse(v)" class="btn">使用</div>
            </div>
          </div>
          <div class="time">备注：{{v.note}}</div>
        </div>
        <div v-if="cur=='get'" v-for="(v,k) in coupon" v-bind:key="k" class="item">
          <div class="box">
            <div class="num">
              ￥<span>{{v.money}}</span>
            </div>
            <div class="txt">
              <p class="tit">{{v.title}}</p>
              <!-- <p class="stit">余额充值券</p> -->
            </div>
            <div class="btnbox">
              <div @click="couponGet(v)" class="btn">领取</div>
            </div>
          </div>
          <div class="time">
            <p>好友祝福：{{v.note}}</p>
            <p v-if="v.expire_at">有效期限至：{{v.expire_at}}</p>
          </div>
        </div>
        <div v-if="cur=='back'" v-for="(v,k) in coupon" v-bind:key="k" class="item">
          <div class="box">
            <div class="num">
              ￥<span>{{v.money}}</span>
            </div>
            <div class="txt">
              <p class="tit">{{v.title}}</p>
              <!-- <p class="stit">余额充值券</p> -->
            </div>
            <div class="btnbox">
              <div v-if="v.type==2" @click="transfer(v)" class="btn">转赠</div>
              <div @click="couponUse(v)" class="btn">使用</div>
            </div>
          </div>
          <div class="time">备注：{{v.note}}</div>
        </div>
        <div v-if="cur=='used'" v-for="(v,k) in coupon" v-bind:key="k" class="item used">
          <div class="box">
            <div class="num">
              ￥<span>{{v.money}}</span>
            </div>
            <div class="txt">
              <p class="tit">{{v.title}}</p>
              <!-- <p class="stit">余额充值券</p> -->
            </div>
            <div class="tips">已充值到个人余额</div>
            <!-- <div class="btnbox">
              <div class="btn">删除</div>
            </div> -->
          </div>
        </div>
      </div>
      <div v-else class="nodata">暂无数据</div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      cur:'enable',
      data:{},
      coupon:[]
    }
  },
  mounted(){
    this.getAccountCoupon();
  },
  methods:{
    getAccountCoupon(){
      let vm = this;
      vm.ajax("account/coupon", "get", '', e => {
        vm.data = e.data;
        vm.coupon = e.data[vm.cur];
      })
    },
    selcur(cur){
      let vm = this;
      vm.cur = cur;
      vm.coupon = vm.data[cur];
    },
    transfer(v){
      this.$router.push({ name: 'cardtransfer',query:{id:v.id} })
    },
    couponGet(v){
      let vm = this;
      if(!(v.id>0)){
        vm.publics.message.danger('该优惠券不存在！');
        return false;
      }
      vm.ajax("account/coupon/get", "post", {
        id:v.id
      }, e => {
        vm.publics.message.success('领取成功');
        vm.getAccountCoupon();
      })
    },
    couponUse(v){
      let vm = this;
      if(!(v.id>0)){
        vm.publics.message.danger('该优惠券不存在！');
        return false;
      }
      vm.ajax("account/coupon/use", "post", {
        id:v.id
      }, e => {
        vm.publics.message.success('优惠券充值成功，请查看个人余额');
        vm.getAccountCoupon();
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mycard.vue